import { RenewalAlert } from '@policyvision/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { changeRenewalAlerts } from '../api/ChangeRenewalAlerts';

interface ChangeRenewalAlertsParams {
  renewalUuid: string;
  alerts: RenewalAlert[];
}

export const useChangeRenewalAlerts = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ renewalUuid, alerts }: ChangeRenewalAlertsParams) =>
      changeRenewalAlerts(renewalUuid, alerts),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['renewals'] });
      queryClient.invalidateQueries({
        queryKey: ['renewal', variables.renewalUuid],
      });
    },
  });

  return {
    changeAlerts: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
